import { ROUTES as e, registerEntityEndpoint as t } from "@editor/ui-utils";
//#endregion
//#region src/lang/category/index.ts
var n = {
	en: {
		assemblerCategoryList: {
			newButton: "New category",
			searchLabel: "Search by category name",
			categoryName: "Category name",
			categoryType: "Category type",
			feedsCount: "Feeds count",
			categoryDeleted: "Category deleted",
			errorOnDeleting: "Error on deleting",
			messagedeleteAssemblerCategory: "Delete category",
			messagedeleteAssemblerCategoryTitle: "Are you sure you want to delete this category?",
			edit: "Edit",
			view: "View",
			duplicate: "Duplicate",
			delete: "Delete",
			all: "All",
			partner: "Partner",
			agency: "Agency"
		},
		assemblerCategoryEdit: {
			categoryId: "Vibe category ID",
			categoryFeedsLabel: "Category feeds",
			selectFeed: "Select feed",
			requiredFields: "The assembler category cannot be saved because mandatory information is missing.",
			errorFailedLoadedCategoryWithId: "Error getting the assembler category",
			messageSaved: "Assembler category saved"
		}
	},
	de: {
		assemblerCategoryList: {
			newButton: "Neue Kategorie",
			searchLabel: "Nach Kategoriename suchen",
			categoryName: "Kategoriename",
			categoryType: "Kategorietyp",
			feedsCount: "Anzahl der Feeds",
			categoryDeleted: "Kategorie gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			messagedeleteAssemblerCategory: "Kategorie löschen",
			messagedeleteAssemblerCategoryTitle: "Willst du diese Kategorie wirklich löschen?",
			edit: "Bearbeiten",
			view: "Ansehen",
			duplicate: "Duplizieren",
			delete: "Löschen",
			all: "Alle",
			partner: "Partner",
			agency: "Agentur"
		},
		assemblerCategoryEdit: {
			categoryId: "VIBE-Kategorie-ID",
			categoryFeedsLabel: "Kategorie-Feeds",
			selectFeed: "Feed auswählen",
			requiredFields: "Die Assembler-Kategorie kann nicht gespeichert werden, weil Pflichtangaben fehlen.",
			errorFailedLoadedCategoryWithId: "Fehler beim Laden der Assembler-Kategorie",
			messageSaved: "Assembler-Kategorie gespeichert"
		}
	}
}, r = {
	en: {
		assemblerTitles: {
			assembler: { routeTitle: "Assembler Content" },
			partner: { routeTitle: "Partner Content" },
			agency: { routeTitle: "Agency Content" },
			categories: { routeTitle: "Partner Categories" },
			feeds: { routeTitle: "Partner Feeds" }
		},
		assemblerList: {
			title: "Partner content",
			newButton: "New Assembler",
			searchLabel: "Search in title or lead text",
			deleteAssembler: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading Assembler",
			headerTeaser: "Teaser image",
			headerSummary: "Article overview",
			headerBrands: "Brand",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Change date",
			counter: "Assembler counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createAssembler: "Create Assembler",
			partner: "Partner",
			partnerMissing: "Partner missing",
			partnerExpired: "Expired",
			fixum: "Fixum",
			revShare: "Revenue share",
			layout: {
				table: "Table",
				grid: "Grid",
				list: "List"
			},
			automaticPollingOn: "We are checking for new articles automatically every {interval} seconds. Click here to check for new articles immediately",
			automaticPollingOff: "We are not checking for new articles right now. Click here to turn it on",
			newBreakingNewsArticle: "A new breaking-news article has arrived!",
			openPreview: "Open article preview",
			showBookmarkedArticles: "Show bookmarked articles",
			noBookmarksSaved: "You don't have any bookmarks saved.",
			retentionBookmarkSyncError: "Could not sync bookmark with the server. Your list is still updated locally.",
			versions: "Versions",
			latestVersion: "Latest version",
			newVersionAvailable: "New version available",
			versionsLoadingError: "Could not load article versions.",
			visibilitySettings: {
				actions: "Action",
				brands: "Brands",
				categories: "Categories",
				date: "Dates",
				partner: "Partner",
				leadtext: "Lead text",
				tags: "Tags (breaking news, urgency etc.)",
				teaser: "Teaser image",
				bookmarks: "Bookmarks",
				versions: "Versions",
				versionsAll: "All",
				versionsImported: "Imported into CTF",
				versionsNone: "Hidden"
			},
			searchFields: {
				title: "Headline",
				leadText: "Lead text",
				articleTags: "Article tags",
				content: "Article text",
				searchIn: "Search in",
				setDefault: "Set as default"
			},
			isVisibleInListing: "Visible in listing",
			hiddenInListing: "Hidden in listing",
			visibleInListingAll: "All",
			visibleInListingTrue: "True",
			visibleInListingFalse: "False",
			articleTags: "Article tags",
			hasCtfUpdateAvailable: "Has updates available",
			hasCtfUpdateAvailableAll: "All",
			hasCtfUpdateAvailableTrue: "True",
			hasCtfUpdateAvailableFalse: "False"
		},
		assembler: {
			assemblerLabel: "Assembler",
			backButton: "Back to Assembler list",
			newAssembler: "New Assembler",
			messageDeleteAssembler: "Delete Assembler",
			messageDeleteAssemblerTitle: "Are you sure you really want to delete this Assembler?",
			deleteAssembler: "Delete",
			messageDeleted: "Assembler deleted",
			errorOnDeleting: "Error deleting the Assembler",
			errorFailedLoadedAssemblerWithId: "Error loading the Assembler",
			dropdownEdit: "Edit",
			dropdownImport: "Import",
			dropdownUpdate: "Update",
			dropdownImportEdit: "Import or edit",
			dropdownSearch: "Search by brand",
			lockedBy: "Locked by:",
			originalArticle: "Original article",
			preview: "Article preview",
			links: "Article links",
			share: "Share",
			feed: "Partner feed",
			partner: "Partner"
		},
		assemblerVersionUpdate: {
			title: "Update {brand} article",
			hint: "Pick the fields to take over from the selected version. Nothing is saved until you save in the editor.",
			continue: "Continue in editor",
			aissistContinue: "Continue",
			current: "Current article",
			selectedVersion: "Selected version",
			selectAll: "Select all",
			changed: "Changed",
			unchanged: "Unchanged",
			notSet: "Not set",
			teaserMissing: "No teaser in selected version",
			copyBlock: "Add block to selected version",
			moveBlock: "Drag to move block",
			moveBlockUp: "Move block up",
			moveBlockDown: "Move block down",
			removeBlock: "Remove block",
			noBlocks: "No content blocks left.",
			loading: "Preparing comparison…",
			selectedCount: "{count} of {total} fields selected",
			loadingError: "Could not prepare the article comparison.",
			diffTooLarge: "Changes could not be highlighted — text too long to compare.",
			imageMetadata: {
				sameImageTitle: "Same image — metadata updated",
				title: "Image changes",
				asset: "Image asset changed",
				caption: "Caption changed",
				credits: "Credits changed"
			},
			fields: {
				title: "Title",
				kicker: "Kicker",
				seoTitle: "SEO title",
				leadText: "Lead text",
				teaser: "Teaser",
				content: "Content body"
			}
		},
		assemblerEdit: {
			label: "Label",
			counter: "Counter",
			backButton: "Back to Assembler list",
			editAssembler: "Edit Assembler",
			messageSaved: "New Assembler saved"
		},
		assemblerTransformer: {
			inlineImageMissingCredit: "One or more inline images have been removed because of missing image credit in the feed",
			mainImageMissingCredit: "The main article image has been removed because of a missing image credit in the feed.",
			inlineImageUploadError: "Error uploading one or more inline images",
			mainImageUploadError: "Error uploading the main article image",
			ctaButtonMissing: "One or more CTA buttons have been removed because they are not available in Vibe.",
			newsletterMissing: "One or more Newsletter blocks have been removed because they are not available in Vibe.",
			newsletterBrandMismatch: "One or more Newsletter blocks belong to a different brand than the one imported for. Please check them in the article.",
			reusableTextMissing: "One or more reusable text blocks have been removed because they are missing in Vibe.",
			reusableTextBrandMismatch: "One or more reusable text blocks belong to a different brand than the one imported for. Please check them in the article.",
			mainImageUpscaled: "Main image has been upscaled due to low resolution. Please check the quality of the image.",
			mainImageUpscaleError: "Upscaling the main image failed. The image has been uploaded in its original resolution."
		},
		assemblerSorting: {
			sort: "Sort",
			createDate: "Import date",
			publishDate: "Publish date"
		},
		assemblerNewPartnerArticle: {
			newPartnerArticle: "New partner article",
			missingPartnerId: "Selected partner ID missing",
			manualCreate: "Create"
		},
		assemblerLinks: {
			articleId: "Article ID",
			originalArticleUrl: "Original article URL",
			previewUrl: "Article preview URL",
			copyToClipboardSuccess: "Successfully copied to clipboard",
			copyToClipboardError: "Error copying to clipboard - please copy the value manually.",
			brandLiveUrl: "{brand} Live Article"
		},
		feedly: {
			feed: "Feed",
			feeds: "Feeds",
			category: "Category",
			categories: "Categories",
			filter: "Filter",
			groupNamePlaceholder: "Enter group name",
			saveAndApplyGroup: "Save group"
		},
		mediatopic: {
			title: "Media topics",
			titleHelp: "Partner and agency articles can include media topics. Filter articles that contain this information here.",
			filter: "Filter",
			groupNamePlaceholder: "Enter group name",
			saveAndApplyGroup: "Save group",
			loadTreeError: "Failed to load mediatopics."
		},
		assemblerContentSource: {
			label: "Source",
			all: "All",
			partner: "Partner",
			other: "Agencies, internal brands, special partners"
		},
		assemblerContentType: {
			label: "Type",
			all: "All",
			content: "Article",
			image: "Image"
		},
		articleTags: {
			"breaking-news": "Breaking news",
			"urgency-1": "Urgency 1",
			"urgency-2": "Urgency 2",
			"urgency-3": "Urgency 3",
			"urgency-4": "Urgency 4",
			"urgency-5": "Urgency 5",
			"urgency-6": "Urgency 6"
		},
		partnersMultiSelector: {
			fieldLabelAgencies: "Agencies",
			fieldLabelPartners: "Partners",
			allAgencies: "All agencies",
			allPartners: "All partners",
			agenciesSearchLabel: "Search by agency",
			partnersSearchLabel: "Search by partner's name",
			groupNamePlaceholder: "Enter group name",
			applyPartnerSelection: "Apply",
			saveAndApplyGroup: "Save group"
		},
		assemblerArticleImport: {
			invalidBrand: "Specified brand is invalid",
			notAllowedBrand: "Specified brand is not allowed for this article",
			alreadyImported: "Article is already imported for this brand",
			versionNotFound: "The selected article version is no longer available",
			importFailed: "Could not import assembler article"
		},
		assemblerNotificationSound: {
			label: "Breaking news notification",
			volumeLabel: "Volume",
			testSoundLabel: "Test"
		},
		assemblerArticleCtfStateSelector: {
			all: "All",
			notImported: "Not imported",
			draft: "Draft",
			schedule: "Scheduled",
			publish: "Published"
		}
	},
	de: {
		assemblerTitles: {
			assembler: { routeTitle: "Assembler Content" },
			partner: { routeTitle: "Partner Content" },
			agency: { routeTitle: "Agenturen Content" },
			categories: { routeTitle: "Partner Kategorien" },
			feeds: { routeTitle: "Partner Feeds" }
		},
		assemblerList: {
			title: "Inhaltsfreigabe",
			newButton: "Neuer Assembler",
			searchLabel: "In Hauptzeile oder Vorspann suchen",
			deleteAssembler: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Lade Assembler",
			headerTeaser: "Artikelbild",
			headerSummary: "Artikel-Übersicht",
			headerBrands: "Marke",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Assembler-Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createAssembler: "Assembler erstellen",
			partner: "Partner",
			partnerMissing: "Partner fehlt",
			partnerExpired: "Abgelaufen",
			fixum: "Fixum",
			revShare: "Revenue Share",
			layout: {
				table: "Tabelle",
				grid: "Raster",
				list: "Liste"
			},
			automaticPollingOn: "Alle {interval} Sekunden wird automatisch geprüft, ob neue Artikel verfügbar sind. Hier klicken, um sofort nach neuen Artikeln zu suchen.",
			automaticPollingOff: "Derzeit wird nicht nach neuen Artikeln gesucht. Zum Aktivieren hier klicken.",
			newBreakingNewsArticle: "Eine neue Eilmeldung ist eingetroffen!",
			openPreview: "Artikelvorschau öffnen",
			showBookmarkedArticles: "Artikel mit Lesezeichen anzeigen.",
			noBookmarksSaved: "Du hast keine Lesezeichen gespeichert.",
			retentionBookmarkSyncError: "Lesezeichen konnte nicht mit dem Server abgeglichen werden. Deine Liste wurde lokal trotzdem aktualisiert.",
			versions: "Versionen",
			latestVersion: "Neueste Version",
			newVersionAvailable: "Neue Version verfügbar",
			versionsLoadingError: "Artikelversionen konnten nicht geladen werden.",
			visibilitySettings: {
				actions: "Aktion",
				brands: "Marken",
				categories: "Kategorien",
				date: "Datum",
				partner: "Partner",
				leadtext: "Vorspann",
				tags: "Tags (Eilmeldung, Dringlichkeit usw.)",
				teaser: "Teaser-Bild",
				bookmarks: "Lesezeichen",
				versions: "Versionen",
				versionsAll: "Alle",
				versionsImported: "In CTF importiert",
				versionsNone: "Ausgeblendet"
			},
			searchFields: {
				title: "Überschrift",
				leadText: "Vorspann",
				articleTags: "Artikel-Tags",
				content: "Artikeltext",
				searchIn: "Suchen in",
				setDefault: "Als Standard festlegen"
			},
			isVisibleInListing: "Sichtbar in Listing",
			hiddenInListing: "Im Listing ausgeblendet",
			visibleInListingAll: "Alle",
			visibleInListingTrue: "Wahr",
			visibleInListingFalse: "Falsch",
			articleTags: "Artikel-Tags",
			hasCtfUpdateAvailable: "Updates verfügbar",
			hasCtfUpdateAvailableAll: "Alle",
			hasCtfUpdateAvailableTrue: "Wahr",
			hasCtfUpdateAvailableFalse: "Falsch"
		},
		assembler: {
			assemblerLabel: "Assembler",
			backButton: "Zurück zur Assembler-Liste",
			newAssembler: "Neuer Assembler",
			messageDeleteAssembler: "Assembler löschen",
			messageDeleteAssemblerTitle: "Willst du diesen Assembler wirklich löschen?",
			deleteAssembler: "Löschen",
			messageDeleted: "Assembler gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Assemblers",
			errorFailedLoadedAssemblerWithId: "Fehler beim Laden des Assemblers",
			dropdownEdit: "Bearbeiten",
			dropdownImport: "Importieren",
			dropdownUpdate: "Aktualisieren",
			dropdownImportEdit: "Importieren oder bearbeiten",
			dropdownSearch: "Suchen nach Marke",
			lockedBy: "Gesperrt von:",
			originalArticle: "Originalartikel",
			preview: "Artikelvorschau",
			links: "Artikel-Links",
			share: "Teilen",
			feed: "Partner-Feed",
			partner: "Partner"
		},
		assemblerVersionUpdate: {
			title: "{brand}-Artikel aktualisieren",
			hint: "Wähle die Felder, die aus der ausgewählten Version übernommen werden. Gespeichert wird erst im Editor.",
			continue: "Im Editor fortfahren",
			aissistContinue: "Weiter",
			current: "Aktueller Artikel",
			selectedVersion: "Ausgewählte Version",
			selectAll: "Alle auswählen",
			changed: "Geändert",
			unchanged: "Unverändert",
			notSet: "Nicht gesetzt",
			teaserMissing: "Kein Teaser in der ausgewählten Version",
			copyBlock: "Block zur ausgewählten Version hinzufügen",
			moveBlock: "Block zum Verschieben ziehen",
			moveBlockUp: "Block nach oben",
			moveBlockDown: "Block nach unten",
			removeBlock: "Block entfernen",
			noBlocks: "Keine Inhaltsblöcke mehr vorhanden.",
			loading: "Vergleich wird vorbereitet…",
			selectedCount: "{count} von {total} Feldern ausgewählt",
			loadingError: "Der Artikelvergleich konnte nicht vorbereitet werden.",
			diffTooLarge: "Änderungen konnten nicht markiert werden — Text zu lang zum Vergleichen.",
			imageMetadata: {
				sameImageTitle: "Gleiches Bild — Metadaten aktualisiert",
				title: "Bildänderungen",
				asset: "Bild-Asset geändert",
				caption: "Bildunterschrift geändert",
				credits: "Bildnachweis geändert"
			},
			fields: {
				title: "Titel",
				kicker: "Kicker",
				seoTitle: "SEO-Titel",
				leadText: "Vorspann",
				teaser: "Teaser",
				content: "Artikelinhalt"
			}
		},
		assemblerEdit: {
			label: "Bezeichnung",
			counter: "Zähler",
			backButton: "Zurück zur Assembler-Liste",
			editAssembler: "Assembler bearbeiten",
			messageSaved: "Neues Assembler gespeichert"
		},
		assemblerTransformer: {
			inlineImageMissingCredit: "Ein oder mehrere Inline-Bilder wurden wegen fehlender Bild-Credits im Feed entfernt.",
			mainImageMissingCredit: "Das Teaserbild wurde entfernt, weil der Feed keinen Bild-Credit enthält.",
			inlineImageUploadError: "Fehler beim Hochladen eines oder mehrerer Inline-Bilder",
			mainImageUploadError: "Fehler beim Hochladen des Hauptartikelbildes",
			ctaButtonMissing: "Ein oder mehrere CTA-Buttons wurden entfernt, da sie in Vibe fehlen.",
			newsletterMissing: "Ein oder mehrere Newsletter-Blöcke wurden entfernt, da sie in Vibe fehlen.",
			newsletterBrandMismatch: "Ein oder mehrere Newsletter-Blöcke gehören zu einer anderen Marke als der, für die importiert wird. Bitte im Artikel überprüfen.",
			reusableTextMissing: "Ein oder mehrere wiederverwendbare Textblöcke wurden entfernt, weil sie in Vibe fehlen.",
			reusableTextBrandMismatch: "Ein oder mehrere wiederverwendbare Textblöcke gehören zu einer anderen Marke als der, für die importiert wird. Bitte im Artikel überprüfen.",
			mainImageUpscaled: "Das Hauptbild wurde wegen niedriger Auflösung hochskaliert. Bitte Bildqualität überprüfen.",
			mainImageUpscaleError: "Wir haben versucht, das Hauptbild zu vergrößern, aber es ist nicht gelungen – das Bild wurde in der Originalauflösung hochgeladen."
		},
		assemblerSorting: {
			sort: "Sortieren",
			createDate: "Datum des Imports",
			publishDate: "Datum der Veröffentlichung"
		},
		assemblerNewPartnerArticle: {
			newPartnerArticle: "Neuer Partnerartikel",
			missingPartnerId: "Ausgewählte Partner-ID fehlt",
			manualCreate: "Erstellen"
		},
		assemblerLinks: {
			articleId: "Artikel-ID",
			originalArticleUrl: "URL des Originalartikels",
			previewUrl: "Artikelvorschau-URL",
			copyToClipboardSuccess: "In die Zwischenablage kopiert",
			copyToClipboardError: "Fehler beim Kopieren in die Zwischenablage. Bitte den Wert manuell kopieren.",
			brandLiveUrl: "{brand} Live Artikel"
		},
		feedly: {
			feed: "Feed",
			feeds: "Feeds",
			category: "Kategorie",
			categories: "Kategorien",
			filter: "Filter",
			groupNamePlaceholder: "Gruppenname eingeben",
			saveAndApplyGroup: "Gruppe speichern"
		},
		mediatopic: {
			title: "Medienthemen",
			titleHelp: "Partner- und Agenturartikel können Medienthemen enthalten. Du kannst Artikel, die diese Informationen beinhalten, hier filtern.",
			filter: "Filter",
			groupNamePlaceholder: "Gruppennamen eingeben",
			saveAndApplyGroup: "Gruppe speichern",
			loadTreeError: "Medienthemen konnten nicht geladen werden."
		},
		assemblerContentSource: {
			label: "Quelle",
			all: "Alle",
			partner: "Partner",
			other: "Agenturen, eigene Marken, Spezialpartner"
		},
		assemblerContentType: {
			label: "Typ",
			all: "Alle",
			content: "Artikel",
			image: "Bild"
		},
		articleTags: {
			"breaking-news": "Eilmeldung",
			"urgency-1": "Dringlichkeit 1",
			"urgency-2": "Dringlichkeit 2",
			"urgency-3": "Dringlichkeit 3",
			"urgency-4": "Dringlichkeit 4",
			"urgency-5": "Dringlichkeit 5",
			"urgency-6": "Dringlichkeit 6"
		},
		partnersMultiSelector: {
			fieldLabelAgencies: "Agenturen",
			fieldLabelPartners: "Partner",
			allAgencies: "Alle Agenturen",
			allPartners: "Alle Partner",
			agenciesSearchLabel: "Suchen nach Agentur",
			partnersSearchLabel: "Suchen nach Partner",
			groupNamePlaceholder: "Gruppennamen eingeben",
			applyPartnerSelection: "Anwenden",
			saveAndApplyGroup: "Gruppe speichern"
		},
		assemblerArticleImport: {
			invalidBrand: "Die angegebene Marke ist ungültig.",
			notAllowedBrand: "Die gewählte Marke ist für diesen Artikel nicht zulässig.",
			alreadyImported: "Der Artikel wurde bereits für diese Marke importiert.",
			versionNotFound: "Die ausgewählte Artikelversion ist nicht mehr verfügbar",
			importFailed: "Assembler-Artikel konnte nicht importiert werden"
		},
		assemblerNotificationSound: {
			label: "Eilmeldungs-Benachrichtigung",
			volumeLabel: "Lautstärke",
			testSoundLabel: "Test"
		},
		assemblerArticleCtfStateSelector: {
			all: "Alle",
			notImported: "Nicht importiert",
			draft: "Entwurf",
			schedule: "Geplant",
			publish: "Veröffentlicht"
		}
	}
}, i = {
	en: {
		feedsSelector: { selectFeed: "Select feed" },
		feedApi: { requiredFields: "Feed cannot be saved because required information is missing" },
		brandName: "{brand}",
		feedList: {
			newButton: "New feed",
			name: "Search by feed name",
			deleteAssemblerFeed: "Delete",
			dpAny: "All",
			active: "Status",
			loading: "Loading feed",
			partner: "Partner",
			feedName: "Feed name",
			feedURL: "Feed URL",
			lastModified: "Last modified",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createFeed: "Create feed",
			secondaryFilters: {
				all: "All",
				true: "True",
				false: "False",
				autopublish: "Autopublish",
				importType: "Feed type",
				periodicPull: "Active import",
				isContentVisibleInCtf: "Content visible in CTF",
				isContentTransformableThroughAI: "Transformable by Aissist"
			}
		},
		feed: {
			feedLabel: "Feed",
			newFeed: "New feed",
			messagedeleteAssemblerFeed: "Delete feed",
			messagedeleteAssemblerFeedTitle: "Are you sure you really want to delete this feed?",
			deleteAssemblerFeed: "Delete",
			duplicateFeed: "Duplicate",
			messageDeleted: "Feed deleted",
			errorOnDeleting: "Error deleting the feed",
			errorFailedLoadedFeedWithId: "Error loading the feed"
		},
		feedEdit: {
			label: "Label",
			counter: "Counter",
			editFeed: "Edit feed",
			messageSaved: "Feed saved",
			fetchMethodTooltip: "GET is the default method for fetching content. POST should be used only in special situations. If you are not sure which method to use, use the GET method."
		},
		feedEditTabs: {
			generalTab: "General",
			contentTab: "Content",
			settingsTab: "Additional settings",
			previewTab: "Preview",
			xmlTab: "XML",
			jsonTab: "JSON",
			historyTab: "History",
			statsTab: "Stats"
		},
		feedEditGeneralTab: {
			feedName: "Feed name",
			feedUrl: "Feed URL",
			feedType: "Feed type",
			activeImport: "Active import",
			cpImport: "CP import",
			publisher: "Partner",
			publisherId: "Vibe partner ID",
			feedId: "Vibe feed ID",
			note: "Note",
			isContentVisibleInCtf: "Content visible in CTF",
			isContentTransformableThroughAI: "Allow Aissist transformation",
			feedFetchMethod: "Feed fetch method",
			contentSyndicationNotAllowedOn: "Brands on which content from this feed may not be published",
			propagateContentSyndication: "Sync",
			propagateContentSyndicationTooltip: "Applies the selected brands (plus partner contract restrictions) to all existing articles of this feed. This may take some time.",
			propagateContentSyndicationStarted: "Updating syndication restrictions on articles has started. This may take some time.",
			propagateContentSyndicationUnsavedChanges: "Save the feed before syncing articles.",
			removeContentAfterDaysToggle: "Set custom article removal period",
			removeContentAfterDaysInput: "Remove content after days"
		},
		feedEditContentTab: { filters: {
			regexPatterns: {
				label: "Regex patterns",
				inputLabel: "Enter pattern"
			},
			whiteListedLinks: {
				label: "Whitelisted links",
				inputLabel: "Enter link"
			},
			htmlPatterns: {
				label: "HTML patterns",
				inputLabel: "Enter pattern"
			}
		} },
		feedEditSettingsTab: {
			eTag: "eTag",
			insertedContent: {
				sectionLabel: "Inserted content blocks",
				newContentBlock: "New content block",
				tooltipText: "You can add text blocks to each article in the feed. They are displayed at the end of the article. Multiple text blocks are possible and can be sorted."
			},
			mapConfig: {
				sectionLabel: "Mapping configuration",
				item: {
					label: "Item",
					path: "Path"
				},
				leadText: {
					label: "Lead text",
					type: "Type",
					path: "Path"
				},
				inlineImages: {
					label: "Inline images",
					wrapperEl: "Inline image path",
					creditsEl: "Credits path",
					captionEl: "Caption path"
				},
				galleries: {
					galleryPublishNote: "Note: Configure gallery publishing on the page “Additional settings → Publish configuration” so the gallery can be imported.",
					groupIntoGallery: "Group inline images into galleries",
					minInlineImagesForGallery: "Minimum number of images per gallery",
					inlineImagesDisabledTooltip: "Inline images must be enabled to group them into galleries."
				}
			},
			modes: {
				sectionLabel: "Authentication",
				authenticationMode: {
					authentication: "Authentication",
					basicAuthUsername: "Username",
					basicAuthPassword: "Password",
					authUrl: "Authentication URL",
					authTokenField: "Token",
					authenticationType: {
						noAuthentication: "No authentication",
						basicAuthentication: "Basic authentication",
						tokenAuthentication: "Token authentication"
					},
					contentCreationType: {
						createOnly: "Create only",
						createUpdate: "Create and update",
						createVersion: "Create and Version"
					}
				},
				contentCreationMode: "Content creation mode"
			},
			additionalSettings: {
				sectionLabel: "Additional settings",
				inactivityNotificationEmail: {
					label: "Inactivity notification email",
					inputLabel: "Enter email"
				},
				importNotificationEmail: {
					label: "Import notification email",
					inputLabel: "Enter email"
				}
			},
			mediatopicAssignment: {
				sectionLabel: "Mediatopic assignment",
				mode: "Assignment mode",
				modes: {
					OFF: "Off",
					FEED_DEFAULTS: "Feed defaults",
					MAP_CATEGORIES: "Map partner categories",
					MAP_CATEGORIES_WITH_DEFAULTS: "Map partner categories with defaults"
				},
				feedDefaultsLabel: "Feed defaults",
				defaultMediatopicIds: "Default mediatopics",
				categoryMappingsLabel: "Category mappings",
				sourcePath: "Source path (e.g. category)",
				splitOn: "Split on (optional, e.g. ,)",
				partnerValue: "Partner value",
				mediatopicIds: "Mediatopics",
				addMapping: "Add mapping"
			},
			publishConfig: {
				sectionLabel: "Publish configuration",
				addNew: "Add new",
				autopublish: "Automatic Publishing",
				channelPrimary: "Primary channel",
				channelsSecondary: "Secondary channels",
				jobGroup: "Team",
				hideFromNewsTicker: "Hide in headline pages",
				hideFromMostRecent: "Hide in stages with newest articles",
				adsEnabled: "Enable ads",
				outstreamEnabled: "Enable Outstream",
				isNoIndex: "Activate noIndex",
				unpublishAfterDaysInput: "Unpublish after … days",
				unpublishAfterDaysToggle: "Unpublish not-bought articles",
				unpublishBoughtAfterDaysToggle: "Unpublish bought articles",
				defaultAuthorsInput: "Default authors",
				areGalleriesEnabled: "Enable galleries",
				defaultGalleryAuthor: "Gallery authors",
				galleryJob: "Gallery BF team",
				galleryChannels: "Gallery channel"
			},
			fetchConfig: {
				sectionLabel: "Fetching configuration",
				priority: "Feed priority",
				contentFetchSchedules: "Content fetch schedules",
				addCustomFetchSchedule: "Add custom fetch schedule",
				addPredefinedFetchSchedule: "Add predefined fetch schedule",
				activeFetchSchedules: "Active fetch schedules",
				invalidCronExpression: "Cron expression not valid",
				fetchSchedules: {
					"10sec": "10 seconds",
					"30sec": "30 seconds",
					"1min": "1 minute",
					"5min": "5 minutes",
					"10min": "10 minutes",
					"30min": "30 minutes",
					"1h": "1 hour",
					"4h": "4 hours",
					"12h": "12 hours",
					custom: "Custom"
				}
			},
			position: "Position",
			positionTooltip: "Set position of the inserted block within the article. Use positive number (0, 1, 2) to position the block as 1st, 2nd ... from the beginning. Use negative number (-1, -2, ...) to position the block as 2nd, 3rd, ... from the end of the article. Use really big number (9999) to position the block as the last block of the whole article.",
			blockType: "Block type",
			placeholderImageConfigs: {
				tooltipText: "If the main image is not found during import, the placeholder image is used. Placeholder images can be configured per brand and must be enabled.",
				sectionLabel: "Placeholder image configs",
				isEnabled: "Enabled",
				imageNotFoundWarning: "Placeholder image for @.capitalize:brandName was not found. Please replace or disable it.",
				imageNotPublishedWarning: "Placeholder image for @.capitalize:brandName is not published. Please replace or disable it.",
				imageNotLicensedWarning: "Placeholder image for @.capitalize:brandName is not licensed. Please replace or disable it.",
				goToImageEditPageLabel: "To image editing"
			}
		},
		feedPreviewTab: {
			errorMessage: "Error loading preview for the feed requested",
			noArticlesErrorMessage: "No articles received for preview. Please verify the feed URL and check your settings.",
			importReady: "Import ready",
			importReadyWithWarnings: "Import ready (contains warnings)",
			notImportReady: "Not import ready",
			validationSummary: "{importReadyCount} of {totalArticles} articles ready for import",
			parseErrors: "Parse errors",
			parseErrorArticle: "Parse error",
			validationIssues: "Import validation",
			noValidationIssues: "No import validation issues.",
			duplicateGuidSibling: "Related article",
			duplicateGuidSiblingOutsidePreview: "{count} more related article(s) are outside the previewed articles.",
			relatedArticleNotInPreview: "The related article is not part of the current preview.",
			severity: {
				error: "Error",
				warning: "Warning"
			}
		},
		feedXmlTab: {
			invalidImportType: "The import type of the feed is not XML.",
			feedSourceFetchError: "Error retrieving feed source",
			feedSourceParseError: "Error parsing the feed source",
			wrapAutoToggleLabel: "Auto-wrap",
			wrapCharSelectLabel: "Break lines",
			copyHtmlLabel: "Copy HTML",
			copyToClipboardSuccess: "HTML copied to clipboard",
			copyToClipboardError: "Failed copying HTML to clipboard"
		},
		publishType: {
			all: "All",
			none: "None",
			auto: "Auto-publish",
			manual: "Manual publish"
		},
		feedHistoryTab: {
			errorContents: "Contents with import error",
			fetchHistory: "Fetch history"
		},
		feedStatsTab: {
			monthLabel: "Month",
			yearLabel: "Year",
			imported: "Imported",
			published: "Published",
			noData: "No statistics for this period"
		}
	},
	de: {
		feedsSelector: { selectFeed: "Feed auswählen" },
		feedApi: { requiredFields: "Feed kann nicht gespeichert werden, weil Pflichtangaben fehlen" },
		brandName: "{brand}",
		feedList: {
			newButton: "Neuer Feed",
			name: "Nach Feed-Name suchen",
			deleteAssemblerFeed: "Löschen",
			dpAny: "Alle",
			active: "Status",
			loading: "Feed wird geladen",
			partner: "Partner",
			feedName: "Feed-Name",
			feedURL: "Feed-URL",
			lastModified: "Zuletzt geändert",
			dpEdit: "Bearbeiten",
			dpView: "Ansicht",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createFeed: "Feed erstellen",
			secondaryFilters: {
				all: "Alle",
				true: "Wahr",
				false: "Falsch",
				autopublish: "Automatisches Veröffentlichen",
				importType: "Feed-Typ",
				periodicPull: "Aktiver Import",
				isContentVisibleInCtf: "Inhalt in CTF sichtbar",
				isContentTransformableThroughAI: "Transformierbar von Aissist"
			}
		},
		feed: {
			feedLabel: "Feed",
			newFeed: "Neuer Feed",
			messagedeleteAssemblerFeed: "Feed löschen",
			messagedeleteAssemblerFeedTitle: "Willst du den Feed wirklich löschen?",
			deleteAssemblerFeed: "Löschen",
			duplicateFeed: "Duplizieren",
			messageDeleted: "Feed gelöscht",
			errorOnDeleting: "Fehler beim Löschen des Feeds",
			errorFailedLoadedFeedWithId: "Fehler beim Abrufen des Feeds"
		},
		feedEdit: {
			label: "Bezeichnung",
			counter: "Zähler",
			editFeed: "Feed bearbeiten",
			messageSaved: "Feed gespeichert",
			fetchMethodTooltip: "GET ist die Standardmethode zum Abrufen von Inhalten. POST sollte nur in besonderen Situationen verwendet werden. Im Zweifel sollte die GET-Methode angewendet werden."
		},
		feedEditTabs: {
			generalTab: "Allgemein",
			contentTab: "Inhalt",
			settingsTab: "Zusätzliche Einstellungen",
			previewTab: "Vorschau",
			xmlTab: "XML",
			jsonTab: "JSON",
			historyTab: "History",
			statsTab: "Statistik"
		},
		feedEditGeneralTab: {
			feedName: "Feed-Name",
			feedUrl: "Feed-URL",
			feedType: "Feed-Typ",
			activeImport: "Aktiver Import",
			cpImport: "CP-Import",
			publisher: "Partner",
			publisherId: "Vibe-Partner-ID",
			feedId: "Vibe-Feed-ID",
			note: "Hinweis",
			isContentVisibleInCtf: "Inhalt in CTF sichtbar",
			isContentTransformableThroughAI: "Aissist-Transformation erlauben",
			feedFetchMethod: "Feed-Abrufmethode",
			contentSyndicationNotAllowedOn: "Marken, auf denen die Inhalte dieses Feeds nicht veröffentlicht werden dürfen",
			propagateContentSyndication: "Synchronisieren",
			propagateContentSyndicationTooltip: "Übernimmt die ausgewählten Marken (einschließlich Partnervertragsbeschränkungen) auf alle bestehenden Artikel dieses Feeds. Dies kann einige Zeit dauern.",
			propagateContentSyndicationStarted: "Die Aktualisierung der Syndizierungsbeschränkungen der Artikel wurde gestartet. Dies kann einige Zeit dauern.",
			propagateContentSyndicationUnsavedChanges: "Speichern Sie den Feed, bevor Sie die Artikel synchronisieren.",
			removeContentAfterDaysToggle: "Benutzerdefinierten Zeitraum für die Artikellöschung festlegen",
			removeContentAfterDaysInput: "Inhalt nach Tagen entfernen"
		},
		feedEditContentTab: { filters: {
			regexPatterns: {
				label: "Regex-Muster",
				inputLabel: "Muster eingeben"
			},
			whiteListedLinks: {
				label: "Links aus der Whitelist",
				inputLabel: "Link eingeben"
			},
			htmlPatterns: {
				label: "HTML-Muster",
				inputLabel: "Muster eingeben"
			}
		} },
		feedEditSettingsTab: {
			eTag: "eTag",
			insertedContent: {
				sectionLabel: "Eingefügte Inhaltsblöcke",
				newContentBlock: "Neuer Inhaltsblock",
				tooltipText: "Zu jedem Artikel im Feed können Textblöcke hinzugefügt werden. Sie werden am Ende des Artikels angezeigt. Es ist möglich, mehrere Textblöcke hinzuzufügen und diese zu sortieren."
			},
			mapConfig: {
				sectionLabel: "Mapping-Konfiguration",
				item: {
					label: "Artikel",
					path: "Pfad"
				},
				leadText: {
					label: "Vorspann",
					type: "Typ",
					path: "Pfad"
				},
				inlineImages: {
					label: "Inline-Bilder",
					wrapperEl: "Inline-Bild-Pfad",
					creditsEl: "Pfad für den Bild-Credit",
					captionEl: "Pfad für die Bildunterschrift"
				},
				galleries: {
					galleryPublishNote: "Hinweis: Bitte die Veröffentlichung der Galerie auf der Seite \"Zusätzliche Einstellungen → Veröffentlichungs­konfiguration\" konfigurieren, damit die Galerie importiert werden kann.",
					groupIntoGallery: "Inline-Bilder zu Galerie gruppieren",
					minInlineImagesForGallery: "Mindestanzahl an Bildern pro Galerie",
					inlineImagesDisabledTooltip: "Inline-Bilder müssen aktiviert sein, um sie in Galerien zu gruppieren."
				}
			},
			modes: {
				sectionLabel: "Authentifizierung",
				authenticationMode: {
					authentication: "Authentifizierung",
					basicAuthUsername: "Benutzername",
					basicAuthPassword: "Passwort",
					authUrl: "Authentifizierungs-URL",
					authTokenField: "Token",
					authenticationType: {
						noAuthentication: "Keine Authentifizierung",
						basicAuthentication: "Basis-Authentifizierung",
						tokenAuthentication: "Token-Authentifizierung"
					},
					contentCreationType: {
						createOnly: "Nur erstellen",
						createUpdate: "Erstellen und aktualisieren",
						createVersion: "Erstellen und versionieren"
					}
				},
				contentCreationMode: "Inhaltserstellungsmodus"
			},
			additionalSettings: {
				sectionLabel: "Zusätzliche Einstellungen",
				inactivityNotificationEmail: {
					label: "Inaktivitäts-Benachrichtigungs-E-Mail",
					inputLabel: "E-Mail-Adresse eingeben"
				},
				importNotificationEmail: {
					label: "Importbenachrichtigungs-E-Mail",
					inputLabel: "E-Mail-Adresse eingeben"
				}
			},
			mediatopicAssignment: {
				sectionLabel: "Mediatopic-Zuordnung",
				mode: "Zuordnungsmodus",
				modes: {
					OFF: "Aus",
					FEED_DEFAULTS: "Feed-Standards",
					MAP_CATEGORIES: "Partner-Kategorien zuordnen",
					MAP_CATEGORIES_WITH_DEFAULTS: "Partner-Kategorien mit Standards zuordnen"
				},
				feedDefaultsLabel: "Feed-Standards",
				defaultMediatopicIds: "Standard-Mediatopics",
				categoryMappingsLabel: "Kategorie-Zuordnungen",
				sourcePath: "Quellpfad (z. B. category)",
				splitOn: "Trenner (optional, z. B. ,)",
				partnerValue: "Partner-Wert",
				mediatopicIds: "Mediatopics",
				addMapping: "Zuordnung hinzufügen"
			},
			publishConfig: {
				sectionLabel: "Veröffentlichungskonfiguration",
				addNew: "Neu hinzufügen",
				autopublish: "Automatische Veröffentlichung",
				channelPrimary: "Primärer Channel",
				channelsSecondary: "Sekundäre Channels",
				jobGroup: "Team",
				hideFromNewsTicker: "Nicht im Newsticker anzeigen",
				hideFromMostRecent: "In Stages mit Auto-Artikeln unterdrücken",
				adsEnabled: "Werbung aktivieren",
				outstreamEnabled: "Outstream aktivieren",
				isNoIndex: "NoIndex aktivieren",
				unpublishAfterDaysInput: "Depublizieren nach … Tagen",
				unpublishAfterDaysToggle: "Depublizieren nicht gekaufter Inhalte",
				unpublishBoughtAfterDaysToggle: "Depublizieren gekaufter Inhalte",
				defaultAuthorsInput: "Standardautoren",
				areGalleriesEnabled: "Galerien aktivieren",
				defaultGalleryAuthor: "Autoren der Galerie",
				galleryJob: "Galerie-BF-Team",
				galleryChannels: "Galerie-Channel"
			},
			fetchConfig: {
				sectionLabel: "Konfiguration abrufen",
				priority: "Feed-Priorität",
				contentFetchSchedules: "Zeitplan für Inhaltsabruf",
				addCustomFetchSchedule: "Benutzerdefinierten Abrufzeitplan hinzufügen",
				addPredefinedFetchSchedule: "Vordefinierten Abrufzeitplan hinzufügen",
				activeFetchSchedules: "Aktive Abrufpläne",
				invalidCronExpression: "Cron-Ausdruck ungültig",
				fetchSchedules: {
					"10sec": "10 Sekunden",
					"30sec": "30 Sekunden",
					"1min": "1 Minute",
					"5min": "5 Minuten",
					"10min": "10 Minuten",
					"30min": "30 Minuten",
					"1h": "1 Stunde",
					"4h": "4 Stunden",
					"12h": "12 Stunden",
					custom: "Benutzerdefiniert"
				}
			},
			position: "Position",
			positionTooltip: "Lege die Position des eingefügten Blocks innerhalb des Artikels fest. Verwende positive Zahlen (0, 1, 2), um den Block als 1., 2. ... vom Anfang aus zu positionieren. Verwende negative Zahlen (-1, -2, ...), um den Block als 2., 3., ... vom Ende des Artikels aus zu positionieren. Verwende sehr große Zahlen (9999), um den Block als letzten Block des gesamten Artikels zu positionieren.",
			blockType: "Blocktyp",
			placeholderImageConfigs: {
				tooltipText: "Ein Symbolbild wird verwendet, wenn kein Bild mitgeliefert wird. Es kann pro Marke separat konfiguriert werden, und es muss per Haken aktiv gesetzt werden.",
				sectionLabel: "Symbolbildkonfiguration",
				isEnabled: "Aktiviert",
				imageNotFoundWarning: "Platzhalter-Bild für @.capitalize:brandName wurde nicht gefunden. Bitte ersetzen oder deaktivieren.",
				imageNotPublishedWarning: "Platzhalter-Bild für @.capitalize:brandName wurde nicht veröffentlicht. Bitte ersetzen oder deaktivieren.",
				imageNotLicensedWarning: "Platzhalter-Bild für @.capitalize:brandName ist nicht lizenziert. Bitte ersetzen oder deaktivieren.",
				goToImageEditPageLabel: "Zur Bildbearbeitung"
			}
		},
		feedPreviewTab: {
			errorMessage: "Fehler beim Laden der Vorschau für den angeforderten Feed",
			noArticlesErrorMessage: "Keine Artikel zur Vorschau verfügbar. Bitte Feed-URL und Einstellungen überprüfen.",
			importReady: "Importbereit",
			importReadyWithWarnings: "Importbereit (mit Warnungen)",
			notImportReady: "Nicht importbereit",
			validationSummary: "{importReadyCount} von {totalArticles} Artikeln importbereit",
			parseErrors: "Parse-Fehler",
			parseErrorArticle: "Parse-Fehler",
			validationIssues: "Import-Validierung",
			noValidationIssues: "Keine Import-Validierungsprobleme.",
			duplicateGuidSibling: "Verwandter Artikel",
			duplicateGuidSiblingOutsidePreview: "{count} weitere verwandte Artikel liegen außerhalb der angezeigten Vorschau.",
			relatedArticleNotInPreview: "Der verwandte Artikel ist nicht Teil der aktuellen Vorschau.",
			severity: {
				error: "Fehler",
				warning: "Warnung"
			}
		},
		feedXmlTab: {
			invalidImportType: "Der Importtyp des Feeds ist nicht XML.",
			feedSourceFetchError: "Fehler bei Abrufen der Feed-Quelle",
			feedSourceParseError: "Fehler beim Parsen der Feed-Quelle",
			wrapAutoToggleLabel: "Automatischer Umbruch",
			wrapCharSelectLabel: "Zeilen umbrechen",
			copyHtmlLabel: "HTML kopieren",
			copyToClipboardSuccess: "HTML in die Zwischenablage kopiert",
			copyToClipboardError: "HTML konnte nicht in die Zwischenablage kopiert werden"
		},
		feedHistoryTab: {
			errorContents: "Inhalt mit Importfehler",
			fetchHistory: "History abrufen"
		},
		feedStatsTab: {
			monthLabel: "Monat",
			yearLabel: "Jahr",
			imported: "Importiert",
			published: "Veröffentlicht",
			noData: "Keine Statistik für diesen Zeitraum"
		},
		publishType: {
			all: "Alle",
			none: "Keine",
			auto: "Automatisches Veröffentlichen",
			manual: "Manuelles Veröffentlichen"
		}
	}
}, a = {
	de: Object.assign({}, n.de, r.de, i.de),
	en: Object.assign({}, n.en, r.en, i.en)
}, o = [
	{
		path: `/${e.assembler.path}`,
		meta: { i18RouteTitleKey: "assemblerTitles.assembler" },
		children: [
			{
				path: "",
				name: "assembler_page",
				meta: { requiredRight: "assemblers:navigate" },
				component: () => import("./assembler-list-wrapper.view-Cp6a0_c5.js"),
				redirect: {
					name: "assembler_partner_list",
					replace: !0
				},
				children: [{
					path: "partner",
					name: "assembler_partner_list",
					component: () => import("./assembler-list.view-BHsuBYLh.js"),
					props: () => ({
						assemblerType: "partner",
						backRoute: "/assembler/partner"
					}),
					meta: {
						i18RouteTitleKey: "assemblerTitles.partner",
						requiredRight: "assemblers:navigate"
					}
				}, {
					path: "agency",
					name: "assembler_agency_list",
					component: () => import("./assembler-list.view-BHsuBYLh.js"),
					props: () => ({
						assemblerType: "agency",
						backRoute: "/assembler/agency"
					}),
					meta: {
						i18RouteTitleKey: "assemblerTitles.agency",
						requiredRight: "assemblers:navigate"
					}
				}]
			},
			{
				path: ":id",
				name: "assembler_detail",
				component: () => import("./assembler-detail.view-C6wLhK3B.js"),
				props: (e) => ({ id: e.params.id }),
				meta: { requiredRight: "assemblers:navigate" }
			},
			{
				path: "import/:brand/:id",
				name: "assembler_article_import",
				component: () => import("./assembler-article-import.view-DJz1166d.js"),
				props: (e) => {
					let t = e.query.version, n = typeof t == "string" && t !== "" && !Number.isNaN(Number(t)) ? Number(t) : void 0;
					return {
						brand: e.params.brand,
						id: e.params.id,
						version: n
					};
				},
				meta: { requiredRight: ["assemblers:read", "articles:edit"] }
			}
		]
	},
	{
		path: "/assembler-categories",
		meta: { i18RouteTitleKey: "assemblerTitles.categories" },
		children: [
			{
				path: "",
				name: "assembler_category_list",
				component: () => import("./category-list.view-Lh5Y6nPI.js"),
				meta: { requiredRight: "partners:manage" }
			},
			{
				path: "new",
				name: "assembler_category_new",
				component: () => import("./category-edit.view-tXsJ2fzQ.js"),
				props: () => ({ backRoute: "/assembler-categories" }),
				meta: { requiredRight: ["partners:manage"] }
			},
			{
				path: ":id",
				name: "assembler_category_detail",
				component: () => import("./category-edit.view-tXsJ2fzQ.js"),
				props: (e) => ({
					id: e.params.id,
					backRoute: "/assembler-categories",
					tab: e.query.tab
				}),
				meta: { requiredRight: ["partners:manage"] }
			}
		]
	},
	{
		path: "/assembler-feeds",
		meta: { i18RouteTitleKey: "assemblerTitles.feeds" },
		children: [
			{
				path: "",
				name: "assembler_feed_list",
				component: () => import("./feed-list.view-CwOAH8Wg.js"),
				meta: { requiredRight: "partners:manage" }
			},
			{
				path: "new",
				name: "assembler_feed_new",
				component: () => import("./feed-edit.view-DD_898ax.js"),
				props: () => ({ backRoute: "/assembler-feeds" }),
				meta: { requiredRight: ["partners:manage"] }
			},
			{
				path: ":id",
				name: "assembler_feed_detail",
				component: () => import("./feed-edit.view-DD_898ax.js"),
				props: (e) => ({
					id: e.params.id,
					backRoute: "/assembler-feeds",
					tab: e.query.tab
				}),
				meta: { requiredRight: ["partners:manage"] }
			}
		]
	}
], s = "AssemblerFetchEvent", c = t(s, "/cms/assembler/fetch-events"), { listEntities: l } = c, u = async (e = {}) => l(e), d = () => ({
	_id: "ac2d7973-c662-4266-8f90-ff164dd31e25",
	feedUuid: "71b6a392-798f-462c-8fd6-61b8ec5372cf",
	isProcessing: !1,
	result: "success",
	startDate: /* @__PURE__ */ new Date()
}), f = {
	messages: a,
	routes: o
};
//#endregion
export { s as AssemblerFetchEventModelName, c as AssemblerFetchEventService, f as assemblerModule, u as getAssemblerFetchEventList, d as getEmptyAssemblerFetchEvent };

//# sourceMappingURL=index.es.js.map